module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-152952062-1"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ideal Capital Group","short_name":"Ideal Capital Group","start_url":"/","background_color":"#0076a8","theme_color":"#0076a8","icon":"src/images/icon.png","display":"browser"},
    }]
